// @flow
import React from "react";

import SectionHeader from "./commons/SectionHeader";
import Section from "./commons/Section";

const STYLE_LI = {
  margin: "10px 0",
};

const Histoire = () => {
  return (
    <div style={{}}>
      <SectionHeader>Notre boutique</SectionHeader>
      <Section>
        <p style={{ textAlign: "justify", margin: "40px 0 50px 0", textAlign: "center", fontWeight: "bold", fontSize: "20px", lineHeight: "20px" }}>
          <a href="https://boutique.champagnedevillepin.fr/">
            <img src="cart.png" alt="boutique" style={{verticalAlign: "middle"}}/>
            <span style={{verticalAlign: "middle"}}>Ouvrir la boutique</span>
          </a>
        </p>
      </Section>
    </div>
  );
};

export default Histoire;



// WEBPACK FOOTER //
// ./src/Boutique.js